import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-order-list',
  templateUrl: './complaint-order-list.component.html',
  styleUrls: ['./complaint-order-list.component.scss']
})
export class ComplaintOrderListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
